import { SetControllerApi } from "src/api/api";

export interface IWorkoutSetApiClients {
    workoutSet: SetControllerApi;
}

export class WorkoutSetApiClients {
    private static instance: IWorkoutSetApiClients;

    private constructor() { }

    static getInstance(basePath: string): IWorkoutSetApiClients {
        if (WorkoutSetApiClients.instance == null) {
            WorkoutSetApiClients.instance = {
                workoutSet: new SetControllerApi({
                    basePath: basePath,
                    isJsonMime() {
                        return true;
                    }
                }),
            };
        }
        return WorkoutSetApiClients.instance;
    }
}